
define('ldsh!modules/form_editor/templates/editor_textarea', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="editor-form-group ed-form-group">\n    <label class="control-label" for="" data-i18n="[text]formEditor.textAreaSize">Tamaño</label>\n    <input type="text"\n           class="form-control js-rows"\n           placeholder="4"\n           value="' +
((__t = ( rows )) == null ? '' : __t) +
'"\n    />\n</div>\n';

}
return __p
};});

